var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSearchCheckNew = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 65.625,
    height: 65.625,
    rx: 6.5625,
    fill: "#EBF6EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1726_8695",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.125,
    y: 13.125,
    width: 39.375,
    height: 39.375,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1726_8695)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5312 39.375C32.2656 39.375 34.5898 38.418 36.5039 36.5039C38.418 34.5898 39.375 32.2656 39.375 29.5312C39.375 26.7969 38.418 24.4727 36.5039 22.5586C34.5898 20.6445 32.2656 19.6875 29.5312 19.6875C26.7969 19.6875 24.4727 20.6445 22.5586 22.5586C20.6445 24.4727 19.6875 26.7969 19.6875 29.5312C19.6875 32.2656 20.6445 34.5898 22.5586 36.5039C24.4727 38.418 26.7969 39.375 29.5312 39.375ZM27.8086 35.3555L37.0781 26.0449L34.7402 23.707L27.8086 30.6797L24.3223 27.2344L21.9844 29.5312L27.8086 35.3555ZM29.5312 42.6562C25.8672 42.6562 22.7637 41.3848 20.2207 38.8418C17.6777 36.2988 16.4062 33.1953 16.4062 29.5312C16.4062 25.8672 17.6777 22.7637 20.2207 20.2207C22.7637 17.6777 25.8672 16.4062 29.5312 16.4062C33.1953 16.4062 36.2988 17.6777 38.8418 20.2207C41.3848 22.7637 42.6562 25.8672 42.6562 29.5312C42.6562 31.0625 42.417 32.5049 41.9385 33.8584C41.46 35.2119 40.7832 36.4492 39.9082 37.5703L49.2188 46.9219L46.9219 49.2188L37.5703 39.9082C36.4492 40.7832 35.2119 41.46 33.8584 41.9385C32.5049 42.417 31.0625 42.6562 29.5312 42.6562Z",
    fill: "#008908"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearchCheckNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search-check-new.26f9adac.svg";
export { ForwardRef as ReactComponent };